import React from 'react'
import background from '../images/kindBg.jpg'
 
export default ({ children }) => (
  
  <div
    style={{
      width: '100vw',
      height: '100vh',
      backgroundImage: `url(${background})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      padding: '50px 20px',
      display: 'flex',
      justifyContent:'center',
      alignItems:'center',
      flexDirection:'column',
      textAlign:'center'
    }}>
    {children}
  </div>
)